import React from 'react';

import theme from 'theme';

type BdNoDataIconProps = {
  /** for display on dark backgrounds */
  dark?: boolean;
};

const BdNoDataIcon: React.FC<BdNoDataIconProps> = ({ dark }) => {
  return (
    <svg
      data-testid="no-data"
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        opacity="0.15"
        data-testid="background"
        cx="18"
        cy="18"
        r="15"
        fill={theme.colors.stone50}
      />
      <path
        data-testid="fill"
        d="M20.3977 11.5967C19.775 11.1299 19.0429 10.8548 18.2822 10.8015C17.5217 10.7399 16.7603 10.9075 16.0857 11.2851C15.4069 11.6583 14.8381 12.2227 14.4417 12.9165C14.0453 13.6103 13.8366 14.4066 13.8386 15.2181C13.8273 15.3105 13.8348 15.4043 13.8605 15.4934C13.8861 15.5825 13.9293 15.6648 13.9873 15.7347C14.0452 15.8047 14.1166 15.8607 14.1965 15.8991C14.2765 15.9375 14.3632 15.9573 14.4509 15.9573C14.5387 15.9573 14.6254 15.9375 14.7054 15.8991C14.7853 15.8607 14.8567 15.8047 14.9146 15.7347C14.9726 15.6648 15.0158 15.5825 15.0414 15.4934C15.0671 15.4043 15.0746 15.3105 15.0633 15.2181C15.0671 14.6468 15.2138 14.0868 15.4885 13.5955C15.7721 13.1108 16.1745 12.7171 16.6525 12.4564C17.1288 12.1922 17.6648 12.0733 18.2009 12.1132C18.737 12.153 19.2522 12.3499 19.6892 12.6821C20.1368 13.0037 20.4881 13.455 20.7014 13.9823C20.9126 14.507 20.9861 15.0825 20.9139 15.6479C20.8404 16.2132 20.6195 16.7454 20.2762 17.1846C19.9425 17.6295 19.4967 17.9648 18.9907 18.1517C18.5229 18.3256 18.1176 18.6497 17.8311 19.0791C17.5445 19.5085 17.3909 20.0218 17.3914 20.548V20.8704C17.3914 21.0443 17.4565 21.211 17.5723 21.3339C17.6881 21.4568 17.8451 21.5259 18.0089 21.5259C18.1726 21.5259 18.3297 21.4568 18.4455 21.3339C18.5613 21.211 18.6263 21.0443 18.6263 20.8704V20.548C18.6234 20.2935 18.698 20.0447 18.8389 19.8388C18.9734 19.6282 19.1688 19.4697 19.3956 19.3875C20.1083 19.1214 20.7409 18.6576 21.2277 18.0442C21.7014 17.426 22.0092 16.6835 22.1185 15.8951C22.2363 15.0796 22.1377 14.2454 21.8338 13.4862C21.5298 12.7269 21.0325 12.0726 20.3977 11.5967Z"
        fill={dark ? theme.colors.stone20 : theme.colors.stone70}
      />
      <path
        d="M17.5487 22.6073C17.4061 22.7025 17.2955 22.842 17.2324 23.0062C17.1665 23.1667 17.1495 23.3445 17.1837 23.5154C17.216 23.6871 17.2981 23.8443 17.4189 23.9652C17.5367 24.0932 17.6899 24.1793 17.8568 24.2113H18.019C18.1302 24.2093 18.2401 24.1863 18.3434 24.1435C18.4992 24.0797 18.6323 23.967 18.7246 23.821C18.7997 23.6753 18.8361 23.5111 18.83 23.3457C18.844 23.1801 18.8113 23.0139 18.736 22.8677C18.6606 22.7214 18.5458 22.6015 18.4059 22.5229C18.266 22.4442 18.1071 22.4103 17.949 22.4253C17.7908 22.4404 17.6403 22.5036 17.5162 22.6073H17.5487Z"
        fill={dark ? theme.colors.stone20 : theme.colors.stone70}
      />
    </svg>
  );
};

export default BdNoDataIcon;
